module.exports = __webpack_public_path__ + "static/media/topLeftDarkBubbles.8aaca6a6.png";